// src/components/VisitorCounter.js

import React, { useState, useEffect } from "react";
import { Box, HStack, Wrap, WrapItem, Text, Icon, Skeleton } from "@chakra-ui/react";
import { FaUsers, FaCircle } from "react-icons/fa";
import apiService from "../services/ApiService";

const REFRESH_INTERVAL_MS = 60 * 1000;

const formatNumber = (value) => Number(value || 0).toLocaleString("th-TH");

const CounterItem = ({ icon, label, value, iconColor = "whiteAlpha.800" }) => (
  <HStack spacing={2}>
    <Icon as={icon} w={3.5} h={3.5} color={iconColor} />
    <Text fontSize="sm">
      {label} :{" "}
      <Text as="span" fontWeight="bold" color="white">
        {formatNumber(value)}
      </Text>
    </Text>
  </HStack>
);

const VisitorCounter = () => {
  const [counter, setCounter] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchCounter = async () => {
      try {
        const response = await apiService({
          method: "POST",
          url: "/getWebsiteVisitCounter",
          data: {},
          sessionId: "",
        });
        if (isMounted && response.result === "success") {
          setCounter(response.counter || {});
        }
      } catch (error) {
        // ถ้าดึงตัวนับไม่สำเร็จ ให้ซ่อนส่วนนี้ไปเลย ไม่ต้องรบกวนผู้ใช้
        console.warn("Fetch visitor counter failed:", error.message);
      }
    };

    fetchCounter();
    const timer = setInterval(fetchCounter, REFRESH_INTERVAL_MS);

    return () => {
      isMounted = false;
      clearInterval(timer);
    };
  }, []);

  if (!counter) {
    return (
      <Box display="flex" justifyContent="center">
        <Skeleton height="18px" width="260px" startColor="whiteAlpha.200" endColor="whiteAlpha.400" />
      </Box>
    );
  }

  return (
    <Wrap spacing={{ base: 4, md: 8 }} justify="center" align="center">
      <WrapItem>
        <CounterItem
          icon={FaUsers}
          label="ผู้เข้าชมทั้งหมด"
          value={counter.TotalVisitors}
        />
      </WrapItem>
      <WrapItem>
        <CounterItem
          icon={FaCircle}
          label="กำลังออนไลน์"
          value={counter.OnlineNow}
          iconColor="green.300"
        />
      </WrapItem>
    </Wrap>
  );
};

export default VisitorCounter;
